import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface BorderGradientCircleProps {
  children: ReactNode;
  className?: string;
}

const BorderGradientCircle: FC<BorderGradientCircleProps> = ({ children, className = '' }) => {
  return (
    <div className={twMerge('h-8 w-8 rounded-full !bg-ph-violet-dark border-glow', className)}>
      {/* <div className="flex h-full w-full items-center justify-center rounded-full bg-phenom-border-glow p-[2px]"> */}
      <div className="flex h-full w-full items-center justify-center rounded-full">{children}</div>
      {/* </div> */}
    </div>
  );
};
export default BorderGradientCircle;
